export default function WhySection() {
  const comparisons = [
    { feature: 'Product Discovery', normal: 'Slow &amp; Manual', sugargoo: 'Organized &amp; Fast' },
    { feature: 'Finding Trends', normal: 'Difficult', sugargoo: 'Effortlessly Easy' },
    { feature: 'Comparing Products', normal: 'Time-Consuming', sugargoo: 'Instant Comparison' },
    { feature: 'Category Browsing', normal: 'Limited &amp; Scattered', sugargoo: 'Fully Structured' },
    { feature: 'Shopping Preparation', normal: 'Hours of Research', sugargoo: 'Minutes to Ready' },
    { feature: 'Price Tracking', normal: 'Manual Checking', sugargoo: 'Curated References' },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100/70 mb-5">
            <span className="text-xs font-medium text-secondary-700 tracking-wide">Comparison</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Why Shoppers Choose Sugargoo Spreadsheet
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            See how the Sugargoo spreadsheet approach transforms your shopping experience compared to traditional methods.
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-background-200/60 bg-background-100/50">
                  <th className="text-left px-5 py-4 font-semibold text-foreground-800 whitespace-nowrap">Feature</th>
                  <th className="text-left px-5 py-4 font-medium text-foreground-500 whitespace-nowrap">
                    <span className="flex items-center gap-1.5">
                      <i className="ri-close-circle-line text-red-400"></i>
                      Traditional Searching
                    </span>
                  </th>
                  <th className="text-left px-5 py-4 font-semibold text-primary-600 whitespace-nowrap">
                    <span className="flex items-center gap-1.5">
                      <i className="ri-checkbox-circle-fill text-accent-500"></i>
                      Sugargoo Spreadsheet
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {comparisons.map((row, i) => (
                  <tr key={row.feature} className={`border-b border-background-200/40 ${i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/30'}`}>
                    <td className="px-5 py-3.5 font-medium text-foreground-800 whitespace-nowrap">{row.feature}</td>
                    <td className="px-5 py-3.5 text-foreground-500 whitespace-nowrap">{row.normal}</td>
                    <td className="px-5 py-3.5 text-accent-700 font-medium whitespace-nowrap">{row.sugargoo}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}